module.exports = __webpack_public_path__ + "img/dateAndTime.2ac14ff5.svg";